module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("61u4U"))).then(() => parcelRequire('1iHdE'));